import * as React from 'react'
import { Column } from '../types'
import { getSystemColumnKeyLabel } from '../helpers'
import I18n from '../../../../libs/i18n'

interface SystemSettingsProps {
  column: Column
  onUpdate: (updates: Partial<Column>) => void
  system_column_keys: string[]
  required_eligible_system_keys: string[]
}

export default function SystemSettings({
  column,
  onUpdate,
  system_column_keys,
  required_eligible_system_keys,
}: SystemSettingsProps) {
  return (
    <div className="d-flex align-items-center">
      <label className="small text-muted mr-2 mb-0">{I18n.t('project_groups.columns_editor.system_field')}</label>
      <select
        className="form-control form-control-sm"
        style={{ width: 200 }}
        value={column.key}
        onChange={(e) => {
          const key = e.target.value
          const updates: Partial<Column> = {
            key,
            label: key ? getSystemColumnKeyLabel(key) : '',
            system_column: true,
          }

          if (!required_eligible_system_keys.includes(key)) {
            updates.required = false
          }

          onUpdate(updates)
        }}
      >
        <option value="">{I18n.t('project_groups.columns_editor.select_field')}</option>
        {system_column_keys.map((key) => (
          <option key={key} value={key}>
            {getSystemColumnKeyLabel(key)}
          </option>
        ))}
      </select>
      <input
        type="text"
        className="form-control form-control-sm ml-2"
        style={{ flex: 1 }}
        placeholder={I18n.t('project_groups.columns_editor.label_placeholder')}
        value={column.label}
        onChange={(e) => onUpdate({ label: e.target.value })}
        disabled={!column.key}
      />
    </div>
  )
}
